import React, { ReactNode } from "react";
import { NavLink } from "react-router-dom";

type NavBarProps = {
  path: string;
  name: string;
  icon: ReactNode;
  classNameContainer?: string;
  classNameIcon?: string;
  classNameLabel?: string;
  onClick?: any;
};

const NavBarButton = (props: NavBarProps) => (
  <NavLink
    onClick={props.onClick}
    to={`/${props.path}`}
    className={`nav-link ${props.classNameContainer &&
      props.classNameContainer}`}
    activeClassName="selected"
  >
    <div className={`nav-icon ${props.classNameIcon && props.classNameIcon}`}>
      {props.icon}
    </div>
    <div
      className={`nav-label ${props.classNameLabel && props.classNameLabel}`}
    >
      {props.name}
    </div>
  </NavLink>
);

export default NavBarButton;
